/* @license react-google-recaptcha-ultimate v1.2.2 */
var c=function(c){return!!document.querySelector("#".concat(c))||!!document.querySelector('script[src*="/recaptcha/"]:not([src*="gstatic"])')};export{c as checkGoogleReCaptchaInjected};
//# sourceMappingURL=checkGoogleReCaptchaInjected.js.map
